export const cegidEkonConfiguration = {
  cegid_ekon_configurations: "Configuraciones de Cegid Ekon",
};
